import { IconButton } from "@mui/material";
import { TbMenu2 } from "react-icons/tb";

import { useSideMenu } from "..";

export const SideMenuToggle = () => {
    const { handleOpenSideMenu } = useSideMenu();
    return (
        <IconButton
            onClick={handleOpenSideMenu}
            sx={{
                color: "rgba(255,255,255,0.5)",
                "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.1)",
                    color: "rgba(255,255,255,0.75)",
                },
            }}
        >
            <TbMenu2 size={24} />
        </IconButton>
    );
};
